import {
	loadAtlassianSwitcher,
	loadJiraSwitcher,
	loadConfluenceSwitcher,
	loadGenericSwitcher,
} from '../../ui/components/loaders';
import { fg } from '@atlaskit/platform-feature-flags';

export default (product?: string) => {
	loadAtlassianSwitcher();

	if (fg('navx-4453-jira-confluence-use-generic-switcher')) {
		return loadGenericSwitcher();
	}

	if (product === 'jira') {
		return loadJiraSwitcher();
	}

	if (product === 'confluence') {
		return loadConfluenceSwitcher();
	}

	return loadGenericSwitcher();
};
